import { getSignedUrl } from "../services/Firebase";

type TokenProvider = {
  getIdToken: () => Promise<string>;
};

export async function resolveMusicUrl(
  musicPath: string,
  currentUser?: TokenProvider | null
): Promise<string> {
  try {
    return await getSignedUrl(musicPath);
  } catch (storageError) {
    if (!currentUser) {
      throw storageError;
    }

    const token = await currentUser.getIdToken();
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/carousel-video/music-preview-url`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ musicPath }),
      }
    );

    if (!response.ok) {
      throw storageError;
    }

    const data = await response.json();
    if (!data.url) {
      throw storageError;
    }

    return data.url;
  }
}
